<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h4 class="card-label">New Template</h4>
    </div>
  </div>

  <div class="form">
    <div class="card-body pt-0 w-100">
      <mat-dialog-content>
        <kt-toe-report-template-form
          [sections]="sections$|async"
          (sectionsChanged)="onSectionsChanged($event)"
        ></kt-toe-report-template-form>
      </mat-dialog-content>
    </div>
    <div class="card-footer b-0 p-0 text-right">
      <div class="form-actions form-actions-solid">
        <button type="button" mat-button mat-raised-button (click)="onClose()">
          Close
        </button>
        &nbsp;
        <button type="button" class="btn btn-success" mat-raised-button color="submit" (click)="onSubmit()">
          Validate
        </button>
      </div>
    </div>
  </div>
</div>